import { IonCardSubtitle, IonCol, IonIcon, IonRow } from "@ionic/react";

const ImgValueComponent = (props: any) => {
  return (
    <IonCol sizeXs="12" sizeMd="6" sizeLg="3">
      <IonRow className="ion-justify-content-center ion-align-items-center customBg">
        <IonCol size="3">
          {/* <img alt="image-placeholder" src={props.src} height="32" width="32" /> */}
          <IonIcon icon={props.src} className="iconplace" size="large" />
        </IonCol>

        <IonCol size="9">
          <IonCardSubtitle>{props.keyText}</IonCardSubtitle>
          {props.value}
        </IonCol>
      </IonRow>
    </IonCol>
  );
};

export default ImgValueComponent;
